// extracted by mini-css-extract-plugin
export default {"products":"sr-z","card":"tr-z","oosMessaging":"ur-z"};